import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
const LEADS_KEY = "leads";
export function useLeads(filters = {}) {
    return useQuery({
        queryKey: [LEADS_KEY, filters],
        queryFn: () => {
            const params = new URLSearchParams();
            if (filters.status)
                params.set("status", filters.status);
            if (filters.manager_id !== undefined)
                params.set("manager_id", String(filters.manager_id));
            params.set("limit", String(filters.limit ?? 20));
            params.set("offset", String(filters.offset ?? 0));
            const qs = params.toString();
            return api.get(`/leads${qs ? "?" + qs : ""}`);
        },
    });
}
export function useLead(id) {
    return useQuery({
        queryKey: [LEADS_KEY, id],
        queryFn: () => api.get(`/leads/${id}`),
        enabled: id > 0,
    });
}
export function useUpdateLead() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }) => api.patch(`/leads/${id}`, data),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: [LEADS_KEY, variables.id] });
            queryClient.invalidateQueries({ queryKey: [LEADS_KEY] });
        },
    });
}
